module.exports = __webpack_public_path__ + "2acb60f2/img/share-icon.0f8a11b4.svg";